// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    bindOnConfirmActions,
    confirmationModalMap
} from '../../services/confirmation-modal-map';
import {
    filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import Audit from '@deere/cps-it.warranty-model-factory/lib/audit';
import AuditListItem from './audit-list-item';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ConfirmationModal from '../../../../shared/components/confirmation-modal';
import ConfirmationModalState from '../../../shared/state/confirmation-modal';
import ListViewShowMore from '../../../../shared/components/list-view-show-more';
import RefinableListWidget from '../../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../../shared/state/search-filters';
import {auditListFilterOptions} from '../../helpers/audit-list-filter-options';
import {auditListSortOptions} from '../../helpers/audit-list-sort-options';

function handleFilterByChange(filterText) {

    this.actions.updateFilterBy(filterText);

}

function handleSortByChange(option) {

    if (option !== this.searchFilters.sortBy[0]) {

        this.actions.updateSortBy(option);

    }

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateSortDirection(sortDirection);

}

function updateSkipAudit(audit) {

    const action = new ClaimAction({
        actionName: 'SKIP_AUDIT',
        id: 'SKIP_AUDIT',
        mode: ''
    });
    const onConfirmActions = bindOnConfirmActions(audit, {
        skipAudit: this.actions.updateSkipAudit
    });

    const actionMethod = confirmationModalMap(action, this.actions.resetConfirmationModal, onConfirmActions);

    this.actions.setConfirmationModal(actionMethod);

}

const AuditList = props => {

    let sortedCollection;

    sortedCollection = [...props.auditList];
    sortedCollection = sortCollection(props.searchFilters.sortBy, props.searchFilters.sortDirection, sortedCollection);
    sortedCollection = filterCollection(props.searchFilters.filterBy, auditListFilterOptions, sortedCollection);

    return (
        <div className='audit-list'>
            <RefinableListWidget
                onFilterByChange={props::handleFilterByChange}
                onSortByChange={props::handleSortByChange}
                onSortDirectionChange={props::handleSortDirectionChange}
                searchFilters={props.searchFilters}
                sortOptions={auditListSortOptions}
            />
            <ListViewShowMore
                initialShowItems={50}
                perMoreMultiplier={1.25}
                showAllOption={true}
                showPerMore={50}
                totalItems={sortedCollection.length}
            >
                {sortedCollection.map((item, index) =>
                    <AuditListItem
                        item={item}
                        key={index}
                        updateSkipAudit={props::updateSkipAudit}
                    />
                )}
            </ListViewShowMore>
            <ConfirmationModal
                confirmMessage={props.confirmationModal.confirmMessage}
                isOpen={props.confirmationModal.isOpen}
                onClose={props.confirmationModal.onClose}
                onConfirm={props.confirmationModal.onConfirm}
                title={props.confirmationModal.title}
            />
        </div>
    );

};

AuditList.displayName = 'AuditList';
AuditList.propTypes = {
    actions: PropTypes.object.isRequired,
    auditList: PropTypes.arrayOf(PropTypes.instanceOf(Audit)).isRequired,
    confirmationModal: PropTypes.instanceOf(ConfirmationModalState).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired
};

export default AuditList;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/audit-list/audit-list.js